import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { Checkbox } from '@shared/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';

export function makeSelectColumn<TData>(): ColumnDef<TData> {
  return {
    id: 'select',
    enableHiding: false,
    enableSorting: false,
    size: 10,
    header: ({ table, column }) => (
      <HeaderCell
        column={column}
        name={
          <Checkbox
            checked={
              table.getIsAllPageRowsSelected() ||
              (table.getIsSomePageRowsSelected() && 'indeterminate')
            }
            onCheckedChange={(value) =>
              table.toggleAllPageRowsSelected(!!value)
            }
            aria-label="Select all"
            className="my-auto translate-y-0.5 place-self-center"
          />
        }
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        // Stop row-level onClick (e.g. navigation) firing when toggling.
        onClick={(e) => e.stopPropagation()}
        aria-label="Select row"
        className="translate-y-0.5"
      />
    ),
  };
}
